import { BooleanInput } from "@angular/cdk/coercion";
import { Component, Inject,OnInit} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as guideMeDropDownData from 'src/assets/guide-me-dropdown.json';
import { environment } from "src/environments/environment";

export interface GuideMeDialog {
  headerTitle: string;
  buttonsHeader: String;
  dropDownHeader: String;
}

@Component({
    selector: 'app-guide-me-dialog',
    templateUrl: './guide-me-dialog.component.html',
    styleUrls: ['./guide-me-dialog.component.scss']
  })
  export class GuideMeDialogComponent implements OnInit {
 
  isChecked : BooleanInput = true;
  guideMeDropDown : any = guideMeDropDownData
  currentDropDown : any;
  selected: any = "UP_TO_6K";
  dropDownOptionId : any;
  selectedDropDownOptionKey : any;
  selectedRadioButtonKey : any;
  currentRadioButtons: any;
  selectedRadioButton: any;
  selectedInnerRadioButtonKey: any;
  currentInnerRadioButtons: any;
  selectedDropDownOption: any
  currentInnerRadioButtonsHeader: any;

  constructor(
      public dialogRef: MatDialogRef<GuideMeDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public input: GuideMeDialog,
    ) {
    }

  ngOnInit(): void {
    this.currentDropDown= this.guideMeDropDown[this.selected];
    this.selectedRadioButton = undefined;
  }
  clearState(){
    this.selectedInnerRadioButtonKey = undefined;
    this.selectedDropDownOptionKey = undefined;
    this.selectedRadioButtonKey = undefined;
  }

  toggle(){
    this.clearState();
    this.selectedRadioButton = undefined;
    this.dropDownOptionId= undefined;
    this.currentDropDown= this.guideMeDropDown[this.selected];
  }

  dropDownSelected(){
    this.clearState();
    this.selectedRadioButton = undefined;
    this.selectedDropDownOption = this.currentDropDown[+this.dropDownOptionId];
    this.selectedDropDownOptionKey = this.selectedDropDownOption['key']
    if(this.selectedDropDownOptionKey ==='radio'){
      this.currentRadioButtons = this.selectedDropDownOption['radioButtons'];
    }
  }

  radioButtonSelected(){
    this.clearState();
    let currKey = this.currentRadioButtons[+this.selectedRadioButton]['key'];
    this.selectedRadioButtonKey = this.currentRadioButtons[+this.selectedRadioButton]['key'];
    if(currKey === 'radio'){
      this.currentInnerRadioButtons = this.currentRadioButtons[+this.selectedRadioButton]['radioButtons'];
      this.currentInnerRadioButtonsHeader = this.currentRadioButtons[+this.selectedRadioButton]['radioButtonHeader'];
    }
  }
  getLink():string | undefined{
    if(this.selectedDropDownOptionKey === 'RFQ' || this.selectedRadioButtonKey === 'RFQ'){
      return "/purchase/rfq/draft";
    }
    else if(this.selectedDropDownOptionKey ==='PCPO' || this.selectedRadioButtonKey === 'PCPO'){
      return "purchase/permissiblecoveringpurchaseorder/draft";
    }
    else if(this.selectedInnerRadioButtonKey === 'T' || this.selectedRadioButtonKey === 'T'){
      return "purchase/tender/draft";
    }
    else if(this.selectedDropDownOptionKey === 'CCCP'){
      return "/purchase/corporatecard/draft";
    }
    else if(this.selectedInnerRadioButtonKey === 'DC'){
      return "purchase/dc/draft";
    }
    return undefined;
  }

  getExternalLinks(){
    if(this.selectedDropDownOptionKey ==='SVP'){
      window.open(environment.mmsURL);
    }
    else if(this.selectedDropDownOptionKey ==='MMS'){
      window.open(environment.mmsURL);
    }
    else if(this.selectedRadioButtonKey ==='CWCT'){
      window.open(environment.ctdUrl);
    } 
    this.closeModal()
  }

  closeModal(){
    this.dialogRef.close();
  }
}